import { Routes, RouterModule } from "@angular/router";
import { AuthComponent } from "./auth.component";
import { SignupComponent } from "./signup/signup.component";

export const routes: Routes = [
  {
    path: "auth",
    component: AuthComponent,
    children: [
      { path: "", redirectTo: "/auth/login", pathMatch: "full" },
      { path: "login", loadChildren:() => import('./login/login.module').then(m => m.LoginModule)},
      {path:"signup",component:SignupComponent}
    //   {
    //     path: "forgotPassword/:id/:token",
    //     component: ForgotPasswordComponent
    //   },
      // { path: "**", redirectTo: "/auth/login" }
    ]
  }
];

export const routing = RouterModule.forChild(routes);
